import { ActividadProyectoItem, ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { ActividadResponse, ActividadTipo } from "../../../shared/response/proyectos/ActividadResponse";
import { ActividadPayload } from "../../../shared/services/api/payload/proyectos/ActividadPayload";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/**
 * Bitácora de un proyecto (`ProyectosPlataformaService`, gRPC). No es un listado global -como los
 * `Service*GetListBase`-, sino uno por proyecto, así que no cachea nada en memoria: cada pantalla de
 * detalle pide su propia lista.
 */
export class ActividadService {
  static readonly instance = new ActividadService();
  private constructor() {}

  /** Entradas del proyecto (`ListActividad`), de la más reciente a la más antigua. */
  async getByProyectoId(proyectoId: string): Promise<ActividadResponse[]> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).listActividad({ id: proyectoId }));
    return r.items.map(toActividadResponse);
  }

  /**
   * Comentario manual (`AgregarComentario`). Las entradas automáticas (creado / editado / estado) las
   * registra el servidor solo.
   */
  async agregarComentario(proyectoId: string, payload: ActividadPayload): Promise<ActividadResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).agregarComentario({
      proyectoId,
      titulo: payload.titulo,
      descripcion: payload.descripcion ?? undefined,
    }));
    return toActividadResponse(r);
  }
}

/** Mensaje gRPC de la entrada → `ActividadResponse`. El contrato no lleva el id del usuario: la web no lo usa. */
function toActividadResponse(a: ActividadProyectoItem): ActividadResponse {
  return {
    id: a.id,
    isEliminado: false,
    proyectoId: a.proyectoId,
    usuarioId: null,
    usuarioNombre: a.usuarioNombre ?? null,
    tipo: a.tipo as ActividadTipo,
    titulo: a.titulo,
    descripcion: a.descripcion ?? null,
    createdAt: Number(a.createdAt),
  };
}
